/**
 * The token of a no-login profile link, as the page handles it. Pure.
 *
 * It arrives once, in `?t=`, and is moved out of the address bar at once —
 * the page loads third-party script (pdf.js) and a token in the URL would ride
 * the Referer. It is kept for the tab's life in sessionStorage, so a refresh
 * does not lose it and closing the tab does.
 */
const KEY = "vc-profile-link-token";

/** Read `?t=` from a search string, or the stored token. */
export function tokenFrom(search, storage) {
  const fromUrl = new URLSearchParams(search || "").get("t");
  if (fromUrl && fromUrl.length >= 20) return { token: fromUrl, fromUrl: true };
  let stored = null;
  try { stored = storage?.getItem(KEY) || null; } catch { stored = null; }
  return { token: stored, fromUrl: false };
}

export function rememberToken(token, storage) {
  try { storage?.setItem(KEY, token); } catch { /* private window, blocked storage */ }
}

export function forgetToken(storage) {
  try { storage?.removeItem(KEY); } catch { /* ignore */ }
}

/** The same address without its `t` parameter. */
export function withoutToken(href) {
  const url = new URL(href);
  url.searchParams.delete("t");
  return url.pathname + (url.search || "") + (url.hash || "");
}
